import { useLocation } from 'react-router-dom';
import { isEnglishPath } from '../data/i18nRoutes';

/** Current locale from URL (`fr` | `en`). */
export function useLocale() {
  const { pathname } = useLocation();
  return isEnglishPath(pathname) ? 'en' : 'fr';
}

export default useLocale;
